import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { CallbackComponent } from 'redux-oidc';
import { replace } from 'connected-react-router';

import userManager from '../../utils/userManager';
import { at } from '../../utils/helpers';
import { fetchProfile } from '../../utils/api';

const ALLOWED_ROLES = [
  'Administrator',
  'Device Administrator',
  'Cabinet Operator',
  'Refill Operator',
];

const Wrapper = styled.div`
  text-align: center;
  margin-top: 50px;
  font-size: 16px;
  color: ${props => props.theme.primary};
`;

const Callback = ({ t, dispatch }) => (
  <CallbackComponent
    userManager={userManager}
    successCallback={user => {
      fetchProfile().then(usr => {
        const roles = usr && usr.roles ? usr.roles : [];
        const intersect = roles.filter(role => ALLOWED_ROLES.includes(role));
        let redirect = at(user, 'state.redirectUrl') || '/';
        if (intersect.length < 1) {
          redirect = '/missing_permission';
        }
        dispatch(replace(redirect));
      });
    }}
    errorCallback={error => {
      dispatch(replace('/signin'));
    }}
  >
    <Wrapper>{t('redirecting')}</Wrapper>
  </CallbackComponent>
);

export default connect()(translate('common')(Callback));
